import React, { useCallback, useEffect } from "react";
import { Button } from "../Button/Button";
import "./_IncrementalButtonInput.scss";

export const IncrementalButtonInput = ({
  value = 1,
  onChange,
  min = 1,
  max,
}) => {
  useEffect(() => {
    if (value > max) {
      onChange(max);
    }
  }, [max]);

  const handleMinus = () => onChange(value - 1);
  const handlePlus = () => onChange(value + 1);

  return (
    <div className="incremental-input">
      <Button
        text="-"
        type="button"
        className="button--primary--number"
        disabled={value === min}
        onClick={handleMinus}
      />
      <span className="incremental-input--value">{value}</span>
      <Button
        text="+"
        type="button"
        className="button--primary--number"
        disabled={value === max}
        onClick={handlePlus}
      />
    </div>
  );
};
